export default "__VITE_ASSET__DUeXy1ae__"